module.exports = __webpack_public_path__ + "img/tommy-full.8453474f.png";